var map = {
	"./axia/icons/patch.png": 545754,
	"./boomea/boomea/icons/patch.png": 351822,
	"./boomea/icons/patch.png": 223284,
	"./simplifi/icons/patch.png": 785234
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 374505;
module.exports = webpackAsyncContext;